// extracted by mini-css-extract-plugin
export default {"locations":"_2a7861df","content":"_67ed26b8"};